<div [class.hidden]="!show">
      <div *ngIf="show" class="loading"></div>
  </div>